<script setup lang="ts">
  import { FormBuilderLayout } from './build';
</script>

<template>
  <FormBuilderLayout />
</template>
